import { useMemo } from 'react';

// FullCalendar usa 0 = domingo ... 6 = sábado.
const DAY_OF_WEEK_INDEX = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const toBusinessHours = (workingHours) =>
  (workingHours ?? []).flatMap((workingDay) => {
    const dayIndex = DAY_OF_WEEK_INDEX[workingDay.dayOfWeek];
    if (dayIndex === undefined) return [];

    return (workingDay.intervals ?? [])
      .filter((interval) => interval.start && interval.end)
      .map((interval) => ({
        daysOfWeek: [dayIndex],
        startTime: interval.start,
        endTime: interval.end,
      }));
  });

/**
 * Converte os horários de atendimento do profissional selecionado no formato
 * `businessHours` do FullCalendar, que pinta de cinza os horários fora do expediente.
 * Recebe a lista já carregada pela tela (`useProfessionalsList`) para não repetir
 * a chamada a /dentists. Retorna `false` (sem destaque) enquanto nenhum
 * profissional estiver selecionado.
 */
export function useBusinessHours(professionals, selectedDentistId) {
  const businessHours = useMemo(() => {
    if (!selectedDentistId) return false;

    const professional = (professionals ?? []).find(
      (item) => String(item.id) === String(selectedDentistId),
    );
    const intervals = toBusinessHours(professional?.workingHours);

    // Sem horários cadastrados não há como distinguir atendimento de folga.
    return intervals.length > 0 ? intervals : false;
  }, [professionals, selectedDentistId]);

  return businessHours;
}
